import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const VisitDetails: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Visit Details
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="body1">
            Visit details page - Coming soon!
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default VisitDetails; 